<template>
  <main class="mdl-layout__content">
    <div class="page-content">
      <p v-if="latest_report_id" class="warning-headline">
        <span v-if="isEuropcarReport() || isAldReport()" v-text="translate('Kjøretøyet er registrert tidligere')"></span>
        <span v-else v-text="translate('Det finnes allerede en')"></span>
        <router-link target="_blank" :to="{ name: 'report', params: { id: latest_report_id }}">takst</router-link>
        <span v-text="translate('på dette kjøretøyet')"></span>
      </p>
      <h1 class="mdl-typography--headline" v-text="translate('1. Kontaktinfo')"></h1>
        <form action="#">
          <template v-if="!isEuropcarReport() && !isAldReport() && !isRentalCheckReport()">
            <h2 class="mdl-typography--title" v-text="translate('Mottaker')"></h2>
            <div class="contact-info mdl-shadow--2dp">
              <template v-if="!$root.isClient()">
                <div class="mdl-selectfield mdl-js-selectfield mdl-selectfield--floating-label" style="width:100%;">
                  <v-select :onChange="onClientChange" :disabled="!isEditable()" placeholder="Velg mottaker" v-model="client" label="name" :options="clients"></v-select>
                </div>
                <div class="v-error" v-if="errors.id_client" v-text="errors.id_client"></div>
              </template>
            </div>
          </template>
          <div class="contact-info mdl-shadow--2dp">
            <div v-if="isEuropcarReport() || isAldReport() || isRentalCheckReport()" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <label class="" v-text="translate('Rapporttype:')"></label>
              <label class="mdl-radio mdl-js-radio mdl-js-ripple-effect" for="status-check-out">
                <input type="radio" id="status-check-out" class="mdl-radio__button" name="report_status" value="5" v-model="report.report_status">
                <span class="mdl-radio__label" v-text="translate('Utsjekk')"></span>
              </label>
              <label class="mdl-radio mdl-js-radio mdl-js-ripple-effect" for="status-check-in">
                <input type="radio" id="status-check-in" class="mdl-radio__button" name="report_status" value="4" checked v-model="report.report_status">
                <span class="mdl-radio__label" v-text="translate('Innsjekk')"></span>
              </label>
            </div>
            <div v-if="isAldReport()" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <label class="">Recipient type:</label>
              <label class="mdl-radio mdl-js-radio mdl-js-ripple-effect" for="status-swap">
                <input type="radio" id="status-swap" class="mdl-radio__button" name="recipient_status" value="1" v-model="report.recipient_status">
                <span class="mdl-radio__label">Swap</span>
              </label>
              <label class="mdl-radio mdl-js-radio mdl-js-ripple-effect" for="status-flexible">
                <input type="radio" id="status-flexible" class="mdl-radio__button" name="recipient_status" value="2" v-model="report.recipient_status">
                <span class="mdl-radio__label">Flexible</span>
              </label>
              <div class="v-error" v-if="errors.recipient_status" v-text="errors.recipient_status"></div>
            </div>
          </div>

          <h2 class="mdl-typography--title">
            <span v-text="translate('Kontaktperson')"></span>
            <span v-if="isEuropcarReport()" v-text="translate('/ Sted / Stasjon')"></span>
          </h2>
          <div class="contact-info mdl-shadow--2dp">
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input autocomplete="off" v-model="report.contact_name" class="mdl-textfield__input" type="text" id="sample1">
              <label class="mdl-textfield__label" for="sample1" v-text="translate('Kontaktperson')"></label>
            </div>
            <div class="v-error" v-if="errors.contact_name" v-text="errors.contact_name"></div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input autocomplete="off" v-model="report.contact_phone" class="mdl-textfield__input" type="text" id="sample2">
              <label class="mdl-textfield__label" for="sample2" v-text="translate('Mobil')"></label>
            </div>
            <div class="v-error" v-if="errors.contact_phone" v-text="errors.contact_phone"></div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input autocomplete="off" v-model="report.contact_email" class="mdl-textfield__input" type="text" id="sample3">
              <label class="mdl-textfield__label" for="sample3" v-text="translate('Epost')"></label>
            </div>
            <div class="v-error" v-if="errors.contact_email" v-text="errors.contact_email"></div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input autocomplete="off" v-model="report.firma" class="mdl-textfield__input" type="text" id="sample4">
              <label class="mdl-textfield__label" for="sample4" v-text="translate('Firma')"></label>
            </div>
            <div class="v-error" v-if="errors.firma" v-text="errors.firma"></div>
          </div>
          <template v-if="isRegularReport() || $root.isSurveyorCapability() || isEuropcarReport() || isAldReport() || isRentalReport()">
            <h2 class="mdl-typography--title" v-text="translate('Rapportvalg')"></h2>
            <div class="contact-info mdl-shadow--2dp">
              <template v-if="isRegularReport() || $root.isSurveyorCapability()">
                <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
                  <input autocomplete="off" v-model="report.referral_number" class="mdl-textfield__input" type="text" id="referral_number">
                  <label class="mdl-textfield__label" for="referral_number" v-text="translate('Referanse / Kontaktsnummer')"></label>
                </div>
                <div v-if="$root.isSurveyorCapability() && !isReportClient('nettbil')">
                  <div class="mdl-textfield">
                    <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="without_price">
                      <input :disabled="!isEditable()" type="checkbox" id="without_price" v-model="report.without_price" class="mdl-checkbox__input">
                      <span class="mdl-checkbox__label" v-text="translate('Taksering uten pris/kostnad')"></span>
                    </label>
                  </div>
                </div>
              </template>
              <div  v-if="isRegularReport() || $root.isSurveyorCapability() || isEuropcarReport() || isAldReport() || isRentalReport()">
                <div class="mdl-textfield">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="english_report">
                    <input class="mdl-checkbox__input" :disabled="!isEditable()" type="checkbox" id="english_report" v-model="report.report_language"
                           true-value="en"
                           false-value="no">
                    <span class="mdl-checkbox__label" v-text="translate('Engelsk rapport')"></span>
                  </label>
                </div>
                <div class="mdl-textfield">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="danish_report">
                    <input class="mdl-checkbox__input" :disabled="!isEditable()" type="checkbox" id="danish_report" v-model="report.report_language"
                           true-value="da"
                           false-value="no">
                    <span class="mdl-checkbox__label" v-text="translate('Dansk rapport')"></span>
                  </label>
                </div>
                <div class="mdl-textfield">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="swedish_report">
                    <input class="mdl-checkbox__input" :disabled="!isEditable()" type="checkbox" id="swedish_report" v-model="report.report_language"
                           true-value="sv"
                           false-value="no">
                    <span class="mdl-checkbox__label" v-text="translate('Svensk rapport')"></span>
                  </label>
                </div>
              </div>
              <div v-if="isRegularReport()">
                <div class="mdl-textfield">
                  <label class="mdl-checkbox mdl-js-checkbox mdl-js-ripple-effect" for="is_condition_report">
                    <input :disabled="!isEditable()" type="checkbox" id="is_condition_report" v-model="report.is_condition_report" class="mdl-checkbox__input">
                    <span class="mdl-checkbox__label" v-text="translate('Inkluder Teknisk Inspeksjon')"></span>
                  </label>
                </div>
              </div>
            </div>
          </template>
          <h2 class="mdl-typography--title" v-text="translate('Info om bil')"></h2>
          <div class="contact-info mdl-shadow--2dp">
            <div v-if="isEuropcarReport() || isAldReport()" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input :disabled="!isEditable()" autocomplete="off" v-model="report.referral_number" class="mdl-textfield__input" type="text" id="contract_referral_number">
              <label class="mdl-textfield__label" for="contract_referral_number" v-text="translate('Kontrakstnummer')"></label>
            </div>
            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input :disabled="!isEditable()" @input="getLatestReport" autocomplete="off" v-model="report.id_car" class="mdl-textfield__input" type="text" id="sample5">
              <p style="margin: 0" v-if="car.model" v-text="car.producer + ' ' + car.model + ' ' + car.year"></p>
              <label class="mdl-textfield__label" for="sample5" v-text="translate('Reg.Nr')"></label>
            </div>
            <div class="v-error" v-if="errors.id_car" v-text="errors.id_car"></div>

            <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input :disabled="!isEditable()" autocomplete="off" v-model="report.car_mileage" class="mdl-textfield__input" type="text" id="sample6">
              <label class="mdl-textfield__label" for="sample6" v-text="translate('Kilometerstand')"></label>
            </div>
            <div class="v-error" v-if="errors.car_mileage" v-text="errors.car_mileage"></div>
            <div v-if="!isEuropcarReport() && !isAldReport()" class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
              <input :disabled="!isEditable()" autocomplete="off" v-model="report.car_market" class="mdl-textfield__input" type="text" id="sample7">
              <label class="mdl-textfield__label" for="sample7" v-text="translate('Markedsverdi')"></label>
            </div>
          </div>
          <template v-if="!isEuropcarReport() && !isAldReport()">
            <h2 class="mdl-typography--title" v-text="translate('Servicehistorikk')"></h2>
            <div class="contact-info mdl-shadow--2dp">
              <div class="mdl-textfield mdl-js-textfield mdl-textfield--floating-label" style="width:100%;">
                <input :disabled="!isEditable()" autocomplete="off" v-model="report.service_history_description" class="mdl-textfield__input" type="text" id="service_history_description">
                <label class="mdl-textfield__label" for="service_history_description" v-text="translate('Eventuelt avvik')"></label>
              </div>

              <div v-for="(shItem,shIndex) in report.service_history">
                <div class="mdl-cell--4-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                  <input :disabled="!isEditable()" autocomplete="off" v-model="shItem[0]" class="mdl-textfield__input" type="text" :id="'sh_date_'+shIndex">
                  <label class="mdl-textfield__label" :for="'sh_date_'+shIndex" v-text="translate('Dato')"></label>
                </div>
                <div class="mdl-cell--4-col mdl-textfield mdl-js-textfield mdl-textfield--floating-label">
                  <input :disabled="!isEditable()" autocomplete="off" v-model="shItem[1]" class="mdl-textfield__input" type="text" :id="'sh_km_'+shIndex">
                  <label class="mdl-textfield__label" :for="'sh_km_'+shIndex">Km</label>
                </div>
              </div>
              <div class="mdl-cell--4-col">
                <div @click="addServiceHistoryItem()" class="mdl-button mdl-js-button mdl-button--icon green">
                  <i class="material-icons">playlist_add</i>
                </div>
              </div>
            </div>
          </template>
        </form>

        <!--<div>
            	<button @click="start()" style="float:left;margin:10px;" class="mdl-button mdl-button--raised">Legg til bilder</button>
            </div>-->

    </div>
    <div class="tab-bar">
      <!-- Colored raised button -->
      <button @click="previous()" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-grey">{{ translate('Avbryt') }}</button>
      <!-- Accent-colored raised button -->
      <button :disabled="$root.ui.isLoading('sendReport')" @click="start()" class="mdl-button mdl-js-button mdl-button--raised mdl-button--colored-green">{{ translate('Til Nøkler og ustyr') }}</button>
    </div>
  </main>
</template>

<script>

  import report from '../mixins/report.js'
  import clients from '../mixins/clients.js'
  import reportValues from '../mixins/reportValues.js'

  import mdlFix from '../mixins/mdlFix.js'
  import utils from '../mixins/utils.js'

  export default {
    data () {
      return {
        is_changed: false,
        is_validated: false
      }
    },
    mixins: [clients, report, reportValues, mdlFix],
    computed: {
      errors: function(){
        if(this.is_validated){
          var e = {};
            if(this.report.contact_phone && !this.report.contact_phone.match(/^\d{8}$/ig))
                e.contact_phone = 'Mobilnummer må fylles ut (8 siffer)';
            if(this.report.contact_email && !this.report.contact_email.match(/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/ig))
                e.contact_email = 'Gyldig e-post må fylles ut';
          /*
          if(!this.report.contact_name)
            e.contact_name = 'Navn må fylles ut';
          if(!this.report.firma)
            e.firma = 'Firma må fylles ut';
          */
          if( !(this.report.id_client || this.report.id_client === 0) )
            e.id_client = 'Kontaktinfo må fylles ut';
          if(!(this.report.id_car && (this.report.id_car.match(/^[A-Z,a-z]{2}\d{5}$/ig) || this.report.id_car.match(/^[A-Z,a-z]{3}\d{3}$/ig))))
            e.id_car = 'Regnr må være på følgende format: AB12345 eller ABC123';
          if(!parseFloat(this.report.car_mileage))
            e.car_mileage = 'Kilometerstand må være et helt tall';
          if(this.isAldReport() && !this.report.recipient_status)
            e.recipient_status = 'Recipient status is required';

          return e;
        }else{
          return {};
        }
      }
    },
    methods: {
      next(){
        var self = this
        var needToSave = false
        var redirect = function(id){
          self.$router.push({ name: 'report-section', params: {id: id, num: 1} });
        }

        if(self.$route.name == 'report-new' || (self.$route.name == 'report-contact' && self.is_changed)) {
          needToSave = true
        }


        if(needToSave && self.isValid()) {
          self.$dialog.confirm('Vil du lagre endringene?', {
            cancelText: 'Avbryt',
            okText: 'Lagre',
            backdropClose: true
          }).then(function () {
            self.sendReport().then(function (data) {
              redirect(data.id ? data.id : self.$route.params.id)
            })
          }).catch(function (err) {
            if(err){
              throw err;
              return;
            }
            if (self.$route.name == 'report-contact'){
                let route = self.$router.resolve({ name: 'report-section', params: {id: self.$route.params.id, num: 1} })
                let href = document.location.origin + document.location.pathname + route.href
                document.location = href
            }
          });
        }else if(self.isValid() && self.$route.name == 'report-contact')
          redirect(self.$route.params.id)
      },
      start(){

	    console.log("START:");
        var self = this
        var needToSave = false
        var redirect = function(id){
	      // images was first section earlier (1.1)
        //   self.$router.push({ name: 'report-images', params: {id: id, num: 1} });
          if (vm.$root.isUser() && vm.$root.user && vm.$root.user.user_login && vm.$root.user.user_login == "tromso.damage") {
            self.$router.push({ name: 'report-images', params: {id: id, num: 2} });
          } else {
            self.$router.push({ name: 'report-section', params: {id: id, num: 1} });
          }
          console.log("Redirect: ")
        }

        if(self.$route.name == 'report-new' || (self.$route.name == 'report-contact' && self.is_changed))
          needToSave = true

        if(needToSave && self.isValid()) {

	      self.sendReport().then(function (data) {
              redirect(data.id ? data.id : self.$route.params.id)
          })

	      /*
          self.$dialog.confirm('Vil du gå til bilder?', {
            cancelText: 'Avbryt',
            okText: 'Lagre',
            backdropClose: true
          }).then(function () {
            self.sendReport().then(function (id) {
              redirect(id ? id : self.$route.params.id)
            })
          }).catch(function (err) {
            if(err){
              throw err;
              return;
            }
            if (self.$route.name == 'report-contact'){
	            console.log("Redirect href");
                let route = self.$router.resolve({ name: 'report-section', params: {id: self.$route.params.id, num: 1} })
                let href = document.location.origin + document.location.pathname + route.href
                document.location = href
            }
          });
          */

        }else if(self.isValid() && self.$route.name == 'report-contact')
          redirect(self.$route.params.id)
      },


      isValid: function(){
        this.is_validated = true;
        return !(Object.keys(this.errors).length);
      },
      onClientChange(client){
          if(client.user_login == 'nettbil')
              this.report.without_price = true;
          this.upgradeMdlDom()
          this.report.id_client = client.id
          return true;
      }
    },
    created: function(){
      var self = this;
      this.$watch(function(){
        return JSON.stringify(this.report, function(key, value) {
            if (typeof value === 'number') {
                return String(value);
            }
            return value;
        })
      },function(after, before){
        var newVal = JSON.parse(after)
        var oldVal = JSON.parse(before)

        if(newVal.is_condition_report != oldVal.is_condition_report)
          this.$root.is_reload_needed = true

        if(newVal.id == oldVal.id)
          this.is_changed = true
        else
          this.is_changed = false
      })
    },
    updated: function(){
        let self = this;
        if(self.$route.name == "report-new" && !self.report.id_client && self.clients.length && (self.isEuropcarReport() || self.isAldReport() || self.isRentalCheckReport())) {
            let c = self.getClientByName("Autotaksering AS");
            self.report.id_client = c.id;
        }
    }
  }
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// ContactForm.vue?3902ceb4